export const responseHandler = {
    handleResponse,
    handleError
};

function handleResponse(response) {
    return new Promise((resolve, reject) => {
        if (response.ok) {
            // Return correct data type.
            var contentType = response.headers.get("content-type");
            if (contentType && contentType.includes("application/json")) {
                response.json().then(json => resolve(json));
            }
            else if (contentType && contentType.includes("text/plain")) {
                response.text().then(text => resolve(text));
            }
            else if (contentType &&
                (contentType.includes("application/vnd.openxmlformats-officedocument.wordprocessingml.document") ||
                    contentType.includes("application/msword"))) {
                let filename = getFilename(response)
                response.blob().then(blob => {
                    blob.name = filename;
                    resolve(blob);
                });
            }
            else if (contentType && contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
                let filename = getFilename(response)
                response.blob().then(blob => {
                    blob.name = filename;
                    resolve(blob);
                });
            }
            else resolve();
        } else {
            response.text().then(text => reject(text));
        }
    });
}

function handleError(error) {
    return Promise.reject(error && error.message);
}

function getFilename(response) {
    var filename = "";
    var disposition = response.headers.get('Content-Disposition');
    if (disposition && disposition.indexOf('attachment') !== -1) {
        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        var matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
        }
    }

    return filename;
}


// WEBPACK FOOTER //
// ./src/helpers/responseHandler.js